import React, { useState } from 'react';
import useStyles from './styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'react-i18next';

interface Props {
  onReset: () => void;
  onStop: () => void;
}

const StopModal: React.FC<Props> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [confirm, setConfirm] = useState(false);
  return (
    <Dialog maxWidth="sm" open={true} fullWidth>
      <DialogContent>
        <p>{t('accountInvestment_stopInfo')}</p>
        <div className={classes.buttonWrapper}>
          <Button
            onClick={props.onReset}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            {t('accountInvestment_changeAnswer')}
          </Button>
          <Button
            onClick={() => setConfirm(true)}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            {t('accountInvestment_stop')}
          </Button>
        </div>
        {confirm && (
          <>
            <p>{t('accountInvestment_stopConfirm')}</p>
            <div className={classes.buttonWrapper}>
              <Button
                onClick={props.onStop}
                variant="contained"
                color="secondary"
                className={classes.button}
              >
                {t('accountInvestment_stop')}
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default StopModal;
